module.exports = __webpack_public_path__ + "static/media/working-on-images.28a4ed22.png";